<template>
  <div class='GiftRegister'>
    <div class="cont-btn">
      <button v-if="$route.path !== '/painel/gift/update'" @click="push">Adicionar</button>
      <button v-if="$route.path === '/painel/gift/update'" @click="update">Atualizar</button>
    </div>
    <div class="cont-form">
      <div class="block-left">
        <input-reg
        v-if="$route.path !== '/painel/gift/update'"
        text="Nome do cupom"
        :value="SelectedGiftEdit.codigo"
        @update:modelValue="newValue => ChangeGiftEdit({ codigo: newValue })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', borderRadius: '5px' }"
        :error="GiftValidate.codigo.$invalid"
        :errorMsg="GiftValidate.codigo.has.$invalid ? GiftValidate.codigo.has.$message : ''"
        />
        <input-select
        text="Tipo de desconto"
        :value="SelectedGiftEdit.tipo"
        @update:modelValue="newValue => ChangeGiftEdit({ tipo: newValue })"
        :data="tipoDesc"
        :label="{ textAlign: 'left', marginTop: '10px', marginLeft: '5px' }"
        :input="{ width: '100%', padding: '2%', fontSize: '16px', borderRadius: '5px' }"
        :error="GiftValidate.tipo.$invalid"
        />
        <input-reg
        text="Valor do cupom"
        :value="SelectedGiftEdit.valor"
        @update:modelValue="newValue => ChangeGiftEdit({ valor: parseFloat(newValue.replace(',', '.')) })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', borderRadius: '5px' }"
        :error="GiftValidate.valor.$invalid"
        />
        <div>
          <div class="label">Validade do cupom:</div>
          <VueDatePicker
          :enable-time-picker="false"
          teleport-center
          locale="pt-br"
          select-text="Selecionar"
          cancel-text="Cancelar"
          @update:model-value="newValue => ChangeGiftEdit({ validade: dateFormat(newValue, 'dd-mm-yyyy') })"
          >
            <template #trigger>
              <input :value="SelectedGiftEdit.validade === '01-01-1900' ? '' : SelectedGiftEdit.validade" class="date-select">
            </template>
          </VueDatePicker>
        </div>
        <input-reg
        text="Limite por cupom"
        :value="SelectedGiftEdit.limiteCupom"
        @update:modelValue="newValue => ChangeGiftEdit({ limiteCupom: parseInt(newValue) })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
        <input-reg
        text="Limite por N produtos"
        :value="SelectedGiftEdit.limiteNprodutos"
        @update:modelValue="newValue => ChangeGiftEdit({ limiteNprodutos: parseInt(newValue) })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
        <input-reg
        text="Limite por usuário"
        :value="SelectedGiftEdit.limiteUser"
        @update:modelValue="newValue => ChangeGiftEdit({ limiteUser: parseInt(newValue) })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
        <!-- <div class="cont-check">
          <input
          :checked="SelectedGiftEdit.freteGratis"
          @change="e => ChangeGiftEdit({ freteGratis: !SelectedGiftEdit.freteGratis })"
          type="checkbox">
          <span>Permitir fréte grátis</span>
        </div>
        <div class="cont-check">
          <input
          :checked="SelectedGiftEdit.individual"
          @change="e => ChangeGiftEdit({ individual: !SelectedGiftEdit.individual })"
          type="checkbox">
          <span>Uso individual</span>
        </div>
        <div class="cont-check">
          <input
          :checked="SelectedGiftEdit.itensVendaDel"
          @change="e => ChangeGiftEdit({ itensVendaDel: !SelectedGiftEdit.itensVendaDel })"
          type="checkbox">
          <span>Excluir Itens de Venda</span>
        </div> -->
        <div class="foo"></div>
      </div>
      <div class="block-right">
        <input-reg
        text="Gasto mínimo"
        :value="SelectedGiftEdit.gastoMin"
        @update:modelValue="newValue => ChangeGiftEdit({ gastoMin: parseFloat(newValue.replace(',', '.')) })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
        <input-reg
        text="Gasto máximo"
        :value="SelectedGiftEdit.gastoMax"
        @update:modelValue="newValue => ChangeGiftEdit({ gastoMax: parseFloat(newValue.replace(',', '.')) })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
        <multi-select
        label="Produtos"
        store="ProdutosGift"
        action="SearchNameProd"
        v-if="SelectedGiftEdit.tipo !== 'Desconto de carrinho fixo'"
        />
        <!-- <multi-select
        label="Excluir produtos"
        store="DelProdutosGift"
        action="SearchNameProd"
        v-if="SelectedGiftEdit.tipo !== 'Desconto de carrinho fixo'"
        /> -->
        <multi-select
        label="Categorias"
        store="CategoriasGift"
        :noSearch="true"
        :srcFixed="Categorias.filter(c => c.name !== '')"
        v-if="SelectedGiftEdit.tipo !== 'Desconto de carrinho fixo'"
        />
        <!-- <multi-select
        label="Excluir categorias"
        store="DelCategoriasGift"
        :noSearch="true"
        :srcFixed="Categorias.filter(c => c.name !== '')"
        v-if="SelectedGiftEdit.tipo !== 'Desconto de carrinho fixo'"
        /> -->
        <input-reg
        text="Emails restritos (separados por , )"
        :value="SelectedGiftEdit.emails"
        @update:modelValue="newValue => ChangeGiftEdit({ emails: newValue })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
import InputSelect from '@/components/EnbPainel/Produtos/Register/InputSelect'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import MultiSelect from './Register/MultiSelect'
import dateFormat from 'dateformat'
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'GiftRegister',
  components: { InputReg, InputSelect, VueDatePicker, MultiSelect },
  computed: {
    ...mapGetters(['Produtos', 'Categorias', 'SelectedGiftEdit', 'GiftValidate']),
    codigo () {
      return this.SelectedGiftEdit.codigo
    },
    tipo () {
      return this.SelectedGiftEdit.tipo
    },
    valor () {
      return this.SelectedGiftEdit.valor
    }
  },
  data () {
    return {
      tipoDesc: [
        {
          id: 0,
          name: 'Desconto Percentual'
        },
        {
          id: 1,
          name: 'Desconto de carrinho fixo'
        },
        {
          id: 1,
          name: 'Desconto de produto fixo'
        }
      ],
      dateFormat: dateFormat
    }
  },
  methods: {
    ...mapActions(['ChangeGiftEdit', 'PushGift', 'PushMsg', 'GetCategory', 'UpdateGift', 'changeGiftValidate', 'VerifyGiftCodHas']),
    async push () {
      let valid = await this.v$.$validate()
      if(!valid) {
        await this.changeGiftValidate(this.v$)
        return
      }
      this.PushGift({
        gift: this.SelectedGiftEdit,
        produtos: this.$store.state.System.ProdutosGift,
        produtoDel: this.$store.state.System.DelProdutosGift,
        categorias: this.$store.state.System.CategoriasGift,
        categoriasDel: this.$store.state.System.DelCategoriasGift
      })
    },
    async update () {
      if(this.v$.tipo.$invalid || this.v$.valor.$invalid) {
        await this.changeGiftValidate(this.v$)
        return
      }
      this.ChangeGiftEdit({
        produtos: this.$store.state.System.ProdutosGift,
        produtoDel: this.$store.state.System.DelProdutosGift,
        categorias: this.$store.state.System.CategoriasGift,
        categoriasDel: this.$store.state.System.DelCategoriasGift
      })
      .then(() => this.UpdateGift())
      this.changeGiftValidate({ tipo: { $invalid: false }, valor: { $invalid: false } })
    },
    async codHas (str) { return await this.VerifyGiftCodHas(str).then(res => res) }
  },
  created () {
    this.GetCategory()
  },
  validations () {
    return {
      codigo: {
        required,
        has: helpers.withMessage('Este código já está sendo utilizado', helpers.withAsync(this.codHas))
      },
      tipo: {
        required
      },
      valor: {
        isNum: (n) => parseInt(n) > 0
      }
    }
  }
}
</script>

<style scoped>
.GiftRegister {
  width: 98%;
  height: 95%;
  padding: 1%;
  overflow: auto;
}

.cont-form {
  display: flex;
}

.block-left {
  width: 50%;
  padding: 1%;
}

.block-right {
  width: 50%;
  padding: 1%;
}

.label {
  font-size: 12px;
  text-align: left;
  margin-left: 3px;
  margin-top: 10px;
  padding-bottom: 1%;
}

.date-select {
  width: 95.5%;
  padding: 2.4%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  font-size: 18px;
}

.cont-check {
  text-align: left;
  padding-top: 3%;
}

.foo {
  width: 100%;
  height: 15%;
}

.cont-btn {
  padding-bottom: 1%;
  text-align: right;
}

button {
  border: 0;
  font-size: 18px;
  padding: 1%;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 2%
}

@media (max-width: 500px) {
  .GiftRegister {
    height: 75%;
  }
  .cont-form {
    display: block;
  }
  .block-left {
    width: 98%;
  }
  .block-right {
    width: 98%;
  }
}
</style>
